export const ENTITY_TYPES = ['url', 'screenName', 'hashtag', 'emoji'] as const;
